import { setAccordionOpen } from './accordion-animation.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-expand-all]').forEach((toggle) => {
        const table = toggle.closest('.column_data')?.querySelector('.section_table')
            ?? toggle.parentElement?.querySelector('.section_table');

        if (!table) return;

        const label = toggle.querySelector('[data-expand-all-label]');
        const expandText = toggle.dataset.expandText;
        const collapseText = toggle.dataset.collapseText;
        const groups = () => Array.from(table.querySelectorAll('details.spec-group'));

        const updateState = () => {
            const allOpen = groups().every((group) => group.open);
            toggle.setAttribute('aria-expanded', String(allOpen));
            if (label) {
                label.textContent = allOpen ? collapseText : expandText;
            }
        };

        toggle.addEventListener('click', () => {
            const shouldOpen = !groups().every((group) => group.open);
            groups().forEach((group) => setAccordionOpen(group, shouldOpen));
        });

        groups().forEach((group) => group.addEventListener('toggle', updateState));

        updateState();
    });
});
